import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ScrollOverflowEnum } from '../scrollable/constants';
import { CAROUSEL_OVERFLOW_FADE_WIDTH } from './constants';
const carouselMaskPartialCSS = ({ overflow = ScrollOverflowEnum.NONE, }) => {
    switch (overflow) {
        case 'right':
            return css `
        mask-image: linear-gradient(
          to left,
          transparent,
          #000 ${CAROUSEL_OVERFLOW_FADE_WIDTH}px
        );
      `;
        case 'left':
            return css `
        mask-image: linear-gradient(
          to right,
          transparent,
          #000 ${CAROUSEL_OVERFLOW_FADE_WIDTH}px
        );
      `;
        case 'both':
            return css `
        mask-image: linear-gradient(
          to right,
          transparent,
          #000 ${CAROUSEL_OVERFLOW_FADE_WIDTH}px,
          #000 calc(100% - ${CAROUSEL_OVERFLOW_FADE_WIDTH}px),
          transparent
        );
      `;
        case 'none':
        default:
            return null;
    }
};
const StyledCarouselContentWrapper = styled.div `
  height: inherit;
  padding: 0 4px;
  overflow: hidden;
  position: relative;
  -webkit-overflow-scrolling: touch;
  will-change: transform;

  ${carouselMaskPartialCSS}
`;
export default StyledCarouselContentWrapper;
